import Parse from '@/parse'

export default {
  initForm ({ state, commit }) {
    if (state.eventQuizset) {
      commit('setQuizset', state.eventQuizset.get('quizset'))
    } else {
      commit('setQuizset', null)
    }
  },

  async get ({ state, commit }) {
    const query = new Parse.Query('EventQuizsetClosed')
    const event = new Parse.Object('EventClosed')
    event.set('objectId', state.eventId)
    query.equalTo('event', event)
    query.include('quizset')
    try {
      let object = await query.first()
      commit('setEventQuizset', object)
      commit('setQuizset', object.get('quizset'))
    } catch (error) {
      console.log(error)
    }
  }
}
